import Vue from 'vue'
import Vuex from 'vuex'
import {api} from './api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        employee: null,
        employee_extended: null,
        account: null,
        errors: null,
        connectionStatus: 'online',
        countries: [],
        marital_statuses: [],
        health_insurance_types: [],
        health_insurance_funds: [],
        genders: [],
        users: [],
        dial_codes: [],
        notifications: [],
        relations: [],
        apps: [],
        expense_form_types: [],
    },
    mutations: {
        updateEmployee: (state, employee) => {
            state.employee = employee
        },
        updateEmployeeExtended: (state, employee_extended) => {
            employee_extended.social_numbers = employee_extended.social_numbers.map(social => {
                if (!social.country) {
                    social.country = {name: null};
                }
                return social;
            })
            state.employee_extended = employee_extended
        },
        profileImage: (state, profile_image) => {
            state.employee.profile_image = profile_image
        },
        updateAccount: (state, account) => {
            state.account = account
        },
        updateNotifications: (state, notifications) => {
            state.notifications = notifications
        },
        setErrors: (state, errors) => {
            state.errors = errors
        },
        clearErrors: (state) => {
            state.errors = null;
        },
        setConnectionStatus(state, status) {
            state.connectionStatus = 'online'
        },
        setCountries: (state, countries) => {
            state.countries = countries
        },
        setMaritalStatuses: (state, items) => {
            state.marital_statuses = items
        },
        setHealthInsuranceTypes: (state, items) => {
            state.health_insurance_types = items
        },
        setHealthInsuranceFunds: (state, items) => {
            state.health_insurance_funds = items
        },
        setGenders: (state, items) => {
            state.genders = items
        },
        setUsers: (state, items) => {
            state.users = items
        },
        setDialCodes: (state, items) => {
            state.dial_codes = items
        },
        setRelations: (state, items) => {
            state.relations = items
        },
        setApps: (state, apps) => {
            state.apps = apps;
        },
        setExpenseFormTypes: (state, expense_form_types) => {
            state.expense_form_types = expense_form_types;
        },
    },
    getters: {
        hasError: (state) => (name) => {
            if (!state.errors) {
                return false
            }

            if (!state.errors.errors) {
                return false
            }

            if (state.errors.errors[name]) {
                return true
            }
        },

        getError: (state) => (name) => {
            if (!state.errors) {
                return null
            }

            if (!state.errors.errors) {
                return null
            }

            if (state.errors.errors[name]) {
                return state.errors.errors[name][0]
            }
        },
    },
    actions: {
        fetchEmployee: ({commit}) => {
            api().get('')
                .then(({data}) => {
                    commit('updateEmployee', data.data.employee)
                    commit('updateAccount', data.data.account)
                    commit('updateNotifications', data.data.notifications)
                })
        },
        fetchEmployeeExtended: ({commit}) => {
            api('hr').get('employee')
                .then(({data}) => {
                    commit('updateEmployeeExtended', data.data)
                })
        },
        fetchCountries: ({commit}) => {
            api('data').get('countries')
                .then(({data}) => {
                    commit('setCountries', data)
                })
        },
        fetchMaritalStatuses: ({commit}) => {
            api('data').get('/?type=marital-statuses')
                .then(({data}) => {
                    commit('setMaritalStatuses', data)
                })
        },
        fetchHealthInsuranceTypes: ({commit}) => {
            api('data').get('/?type=health-insurance-types')
                .then(({data}) => {
                    commit('setHealthInsuranceTypes', data)
                })
        },
        fetchHealthInsuranceFunds: ({commit}) => {
            api('data').get('/?type=health-insurance-funds')
                .then(({data}) => {
                    commit('setHealthInsuranceFunds', data)
                })
        },
        fetchGenders: ({commit}) => {
            api('data').get('genders')
                .then(({data}) => {
                    commit('setGenders', data)
                })
        },
        fetchDialCodes: ({commit}) => {
            api('data').get('dial_codes')
                .then(({data}) => {
                    commit('setDialCodes', data)
                })
        },
        fetchUsers: ({commit}) => {
            return new Promise((resolve, reject) => {
                api().get('all')
                    .then(({data: {data}}) => {
                        commit('setUsers', data)
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        fetchUnreadNotifications: ({commit}) => {
            api().get('unread-notifications')
                .then(({data}) => {
                    commit('updateNotifications', data.data)
                })
        },
        fetchRelations: ({commit}) => {
            api('data').get('/?type=relations')
                .then(({data}) => {
                    commit('setRelations', data)
                })
        },
        fetchApps: ({commit}) => {
            api()
                .get('apps')
                .then(({data}) => {
                    commit('setApps', data.apps);
                })
                .catch((error) => {
                    commit('setApps', null);
                });
        },
        fetchExpenseFormTypes: ({commit}) => {
            api('expenses').get('/sources?type=form_types')
                .then(({data: {data}}) => {
                    commit('setExpenseFormTypes', data)
                })
        }
    }
})
